// extracted by mini-css-extract-plugin
export default {"image":"K1-z","loaded":"L1-z"};